import {put, take} from "redux-saga/effects";
import {enterChestGame, leaveChestGame} from "../../../mini-games/chests/actions";
import {ActionType, getType} from "typesafe-actions";
import {ILevelMapAggregatedTile} from "../../types";

export function* handleChestGameTile(tile: ILevelMapAggregatedTile) {
    yield put(enterChestGame());
    const { payload: chestsProgress }: ActionType<typeof leaveChestGame> = yield take(getType(leaveChestGame));

    return chestsProgress;
}